export const agent = {
    yqmh: "Davet Gizemli Kutusu",
    yqzmh: "Davet Et Kazan Gizemli Kutu",
    bfbkj: "%100 Ödül Kazanma",
    yqpy: "Arkadaşını Davet Et",
    pywczcrw: "Arkadaş kaydolur ve görevleri tamamlar",
    hdcmhcs: "Gizemli Kutu çekiliş hakkı kazan",
    jllb: "Ödül Listesi",
    mhjlbk: "Gizemli Kutu ödülleri şunları içerebilir: {text} Spesifik miktar, gerçekte kazanılan ödüle göre belirlenir!",
    kkcs: "{value} kere açılabilir",
    mhmx: "Gizemli Kutu Detayları",
    jpmx: "Ödül Detayları",
    hdmhs: "Kazanılan Gizemli Kutu Sayısı",
    hyjd: "Arkadaş İlerlemesi",
    jplx: "Ödül Türü",
    dbmc: "Token Adı",
    ypf: "Dağıtıldı",
    wpf: "Dağıtılmadı",
    lq: "Al",
    zblw: "Hediyelik Eşya",
    gxczmh: "Tebrikler {amount} kazandınız, yeni arkadaşlar davet edin, görevleri tamamlayın, gizemli kutu kazanın",
    lxkflq: "Hediyelik eşya ödülleri için lütfen müşteri hizmetleri ile iletişime geçin",
    shdz: "Teslimat Adresi",
    rwmc: "Görev Adı",
    wczt: "Tamamlama Durumu",
    hdmhsl: "Kazanılan Gizemli Kutu Sayısı",
    zblqdz: "Hediyelik Eşya Alma Adresi",
    shr: "Alıcı",
    dh: "Telefon",
    xxdz: "Detaylı Adres",
    yqmhhdgz: "Davet Gizemli Kutu Etkinlik Kuralları",
    yqyl: "1. Biking Davet ve Hediye Nedir?",
    yhhkxt: "Biking Davet ve Hediye, Biking'i benimseyen ve arkadaşlarını Biking'e davet eden sadık kullanıcılarımızı ödüllendirmek için tasarlanmış bir kullanıcı ödül sistemidir.",
    yqhyhdfhjl: "Biking Davet ve Hediye kullanımı kolaydır, kullanıcılar sadece arkadaşlarını davet ederek zengin ödüller kazanabilir.",
    cyhdhqjl: "2. Etkinliğe katılarak görevleri tamamlamak hangi ödülleri getirir?",
    hywcrwhdjl: "Davet eden kişi arkadaşını davet eder, davet edilen kişi ilgili görevleri tamamlarsa, hem davet eden hem de davet edilen kişi Gizemli Kutu kazanır ve ödül için Gizemli Kutu'yu açabilir.",
    mhhdgz: "3. Gizemli Kutu Kazanma Kuralları",
    syrwczc: "1. Davet edilen kişi kaydı ve kimlik doğrulamayı tamamlar —— Davet edilen kişi 1 açılış hakkı kazanır",
    syrcz: "2. Davet edilen kişi ≥100 USDT yatırır —— Davet eden ve davet edilen kişi各 1 açılış hakkı kazanır",
    syrcssxf: "3. Davet edilen kişinin vadeli işlem işlem ücreti ≥30 USDT oluşturur —— Davet eden ve davet edilen kişi各 2 açılış hakkı kazanır",
    qqjyl: "4. Opsiyon işlem hacmi ≥200 USDT —— Davet eden ve davet edilen kişi各 2 açılış hakkı kazanır",
    yxjyl: "5. Gamefi işlem hacmi ≥200 USDT ve sipariş oranı 1.2 katından az olmamalıdır, 1.2 katından düşük oranlı siparişler sayılmaz —— Davet eden ve davet edilen kişi各 2 açılış hakkı kazanır",
    xhmrjyl: "6. Spot alım işlem hacmi ≥500 USDT —— Davet eden ve davet edilen kişi各 1 açılış hakkı kazanır",
    rwqbwc: "Her davet görevinin tamamlanmasıyla, davet eden kişi en fazla 8 Gizemli Kutu açma hakkı kazanabilir, davet edilen kişi tüm hedeflere ulaşırsa en fazla 9 Gizemli Kutu açma hakkı kazanabilir. Birden fazla kişiyi davet etmek, kurallara göre kümülatif olarak Gizemli Kutu kazanma şansını artırır.",
    qtsm: "4. Diğer Açıklamalar",
    mhffsj: "1. Gizemli Kutu dağıtım zamanı -- Arka planda görevler 10 dakikada bir kontrol edilir",
    jlffsj: "2. Ödül dağıtım zamanı -- Arka planda manuel olarak her gün öğlen 12:00'de bir kez dağıtılır",
    syyhjkcj: "3. Tüm kullanıcılar katılabilir, diğer etkinliklerle çakışmaz",
    mhcjs: "4. Gizemli Kutu çekiliş hakkı her ayın 1'inde sıfırlanır",
    yqmts: "Sadece kullanıcıları alt üye olarak davet edin, alt üyelerinizin işlemleri sizin için işlem ücreti komisyonu oluşturur",
    fym: "Komisyon Kodu",
    fymts: "Davet edin ve doğrudan alt üyelere kendi komisyon oranınızdan yüksek olmayan bir komisyon oranı verin, alt üyelerin işlemleri orana göre işlem ücreti komisyonu dağıtır",
    szfym: "Komisyon Kodu Ayarla",
    xzfym: "Yeni Komisyon Kodu Ekle",
    lj: "Bağlantı",
    fybl: "Komisyon Oranı",
    yyqhys: "Davet Edilen Arkadaş Sayısı",
    sykcjs: "Kalan Oluşturma Hakkı",
    tjlx: "Öneri Türü",
    bwjs: "5. Herhangi bir bireyin veya ekibin Gizemli Kutu hediyelerini hileli şekilde kazandığı tespit edilirse, Biking, bu hesapların ödüllerini kesme ve ödül haklarını iptal etme hakkını saklı tutar. Bu hediyelere katılan tüm kullanıcılar resmi hediye şartlarını kabul etmiş sayılır. Biking borsası nihai açıklama hakkını saklı tutar.",
    swmr: "Varsayılan Yap",
    cffym: "Komisyon kodu zaten var, lütfen doğru komisyon kodunu girin",
    qxtjfym: "Lütfen önce bir komisyon kodu ekleyin",
    xywdbl: "10 <= Benim Komisyon Oranım",
    qsrdybl: "Lütfen ilgili oranı girin",
    qsrzqsl: "Lütfen doğru değeri girin",
    qsrbz: "Lütfen açıklama girin",
    bnbhzf: "Özel karakterler veya emojiler içeremez"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/tr.js